// A most-recent-first list of ids in localStorage, capped at `max`. Fails soft:
// a blocked or full store reads as empty and drops the write.
export function readIdList(key, storage = localStorage) {
  try {
    const parsed = JSON.parse(storage.getItem(key) || '[]');
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch (error) {
    return [];
  }
}

export function rememberId(key, id, max, storage = localStorage) {
  if (id == null || id === '') {
    return;
  }
  const value = String(id);
  const kept = [value, ...readIdList(key, storage).filter(existing => existing !== value)];
  try {
    storage.setItem(key, JSON.stringify(kept.slice(0, max)));
  } catch (error) {
    // Full or blocked store: the customer may be asked once more, nothing else.
  }
}
